<div class="filter-container" [ngClass]="{ popCalender: options == null, 'right-justify': rightJustify }">
  @if (options === null) {
    <div class="filter-content date">
      <h2 class="filter-calender-title">Please select {{ ftitle | lowercase }}.</h2>
      @if (!enterDateManually) {
        <div>
          <ngb-datepicker class="filter-calendar" #dp navigation="arrows" (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" [firstDayOfWeek]="0" outsideDays="hidden"> </ngb-datepicker>
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
          @if (!enterDateManually && options == null) {
            <button type="button" class="manual-toggle-btn no-border-btn btn-link font-regular font-light nounderline cursor-pointer" (click)="enterDateManually = true">Enter dates manually</button>
          }
        </div>
      }

      @if (enterDateManually) {
        <div>
          <div class="date-range">
            <form [formGroup]="dateRangeForm" novalidate>
              <mat-form-field appearance="fill" id="startDate">
                <mat-label>Start date</mat-label>
                <input
                  matInput
                  class="input-date"
                  formControlName="selectedDate"
                  [ngModel]="selectedDate"
                  placeholder="MM/DD/YYYY"
                  [minDate]="isOptionsEmpty ? minimumDate : null"
                  [navigation]="datePickerSettings.navigation"
                  [maxDate]="maximumDate"
                  (dateSelect)="onRangeDateSelection($event, true)"
                  (ngModelChange)="onChangeEvent($event, true)"
                  ngbDatepicker
                  [container]="datepickerContainer"
                  [autoClose]="'inside'"
                  [firstDayOfWeek]="0"
                  #d="ngbDatepicker"
                  [outsideDays]="outsideDays"
                  (keypress)="onKeyPress($event)"
                />
                <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="date-icon" (click)="d.toggle()" aria-label="Select Date">
                  <i class="icon-date-range" aria-hidden="true"></i>
                </a>
              </mat-form-field>
              <mat-form-field appearance="fill" id="endDate" class="end-date-picker">
                <mat-label>End date</mat-label>
                <input
                  matInput
                  class="input-date"
                  formControlName="selectedEndDate"
                  [ngModel]="selectedEndDate"
                  placeholder="MM/DD/YYYY"
                  [minDate]="getMinDate()"
                  [maxDate]="maximumDate"
                  [navigation]="datePickerSettings.navigation"
                  (dateSelect)="onRangeDateSelection($event, false)"
                  ngbDatepicker
                  [container]="datepickerContainer"
                  [autoClose]="'inside'"
                  [firstDayOfWeek]="0"
                  (ngModelChange)="onChangeEvent($event, false)"
                  #d1="ngbDatepicker"
                  [outsideDays]="outsideDays"
                  (keypress)="onKeyPress($event)"
                />
                <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="date-icon" (click)="d1.toggle()" aria-label="Select Date">
                  <i class="icon-date-range" aria-hidden="true"></i>
                </a>
              </mat-form-field>
              @if (dateRangeForm.get('selectedEndDate').hasError('dateError') || dateRangeForm.get('selectedDate').hasError('dateError')) {
                <span class="mat-error empty-error"> <i class="icon-warning_white" aria-hidden="true"></i>{{ errorMessage }} </span>
              }
            </form>
          </div>
          @if (enterDateManually) {
            <button type="button" class="manual-toggle-btn no-border-btn btn-link font-regular font-light nounderline cursor-pointer" (click)="backToCalendarView()">Back to Calendar View</button>
          }
        </div>
      }
    </div>
  }

  @if (isOptionsEmpty && !useDatepickerDateRange) {
    <div class="filter-content date-range">
      <form [formGroup]="dateRangeForm" novalidate>
        <mat-form-field appearance="fill" id="startDate" data-cy="start-date-input">
          <mat-label>{{ itemName !== 'Date' ? 'Start date' : 'Date' }}</mat-label>
          <input
            matInput
            class="input-date"
            data-cy="input-date"
            formControlName="selectedDate"
            [ngModel]="selectedDate"
            placeholder="MM/DD/YYYY"
            [minDate]="isOptionsEmpty ? minimumDate : null"
            [navigation]="datePickerSettings.navigation"
            [maxDate]="maximumDate"
            (dateSelect)="onRangeDateSelection($event, true)"
            (ngModelChange)="onChangeEvent($event, true)"
            ngbDatepicker
            [container]="datepickerContainer"
            [autoClose]="'inside'"
            [firstDayOfWeek]="0"
            #d="ngbDatepicker"
            [outsideDays]="outsideDays"
            (keypress)="onKeyPress($event)"
          />
          <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="date-icon" (click)="d.toggle()" aria-label="Select Date">
            <i class="icon-date-range" aria-hidden="true"></i>
          </a>
        </mat-form-field>
        @if (itemName !== 'Date') {
          <mat-form-field appearance="fill" id="endDate" class="end-date-picker">
            <mat-label>End date</mat-label>
            <input
              matInput
              class="input-date"
              data-cy="end-date"
              formControlName="selectedEndDate"
              [ngModel]="selectedEndDate"
              placeholder="MM/DD/YYYY"
              [minDate]="getMinDate()"
              [maxDate]="maximumDate"
              [navigation]="datePickerSettings.navigation"
              (dateSelect)="onRangeDateSelection($event, false)"
              ngbDatepicker
              [container]="datepickerContainer"
              [autoClose]="'inside'"
              [firstDayOfWeek]="0"
              (ngModelChange)="onChangeEvent($event, false)"
              #d1="ngbDatepicker"
              [outsideDays]="outsideDays"
              (keypress)="onKeyPress($event)"
            />
            <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="date-icon" (click)="d1.toggle()" aria-label="Select Date">
              <i class="icon-date-range" aria-hidden="true"></i>
            </a>
          </mat-form-field>
        }
        @if (dateRangeForm.get('selectedEndDate').hasError('dateError') || dateRangeForm.get('selectedDate').hasError('dateError')) {
          <span class="mat-error empty-error"> <i class="icon-warning_white" aria-hidden="true"></i>{{ errorMessage }} </span>
        }
      </form>
    </div>
  }

  @if (options !== null && options.length > 0) {
    <div class="filter-content">
      @if (!isRadio) {
        <app-checkbox-template [filterOptions]="foptions" [filterTitle]="ftitle" [clearFilter]="filterFlag" (dirtyFlagChange)="categoryDirtyChange($event)" data-cy="filter-content" [isAllSelectedOptions]="isAllSelectedOptions">
        </app-checkbox-template>
      }

      @if (isRadio) {
        <div class="radio-group">
          <h2 class="mb-5">Select {{ ftitle }}</h2>
          <div class="section-container">
            @for (option of radioOptions; track option) {
              <mat-radio-group name="paymentSource" data-cy="radio-group">
                @if (option.isVisible) {
                  <span>
                    <mat-radio-button
                      value="{{ option.name }}"
                      [checked]="option.checked"
                      data-cy="radio-option"
                      (change)="
                        categoryDirtyChange({
                          selectedOptions: [option],
                          status: [true],
                          name: ftitle,
                        })
                      "
                    >
                      {{ option.name }}
                    </mat-radio-button>
                  </span>
                }
                @if (option.bankAccounts && radioOptions[0].checked === true) {
                  <div class="pl-5">
                    <mat-radio-group>
                      @for (bankAccount of option.bankAccounts; track bankAccount; let i = $index) {
                        <span>
                          @if (bankAccount.isVisible) {
                            <mat-radio-button
                              name="bankAccount"
                              (change)="
                                categoryDirtyChange({
                                  selectedOptions: [option],
                                  status: [true],
                                  name: ftitle,
                                  bankAccountIndex: i,
                                })
                              "
                              value="{{ bankAccount.id }}"
                              [checked]="bankAccount.checked"
                            >
                              {{ bankAccount.name }}
                            </mat-radio-button>
                          }
                        </span>
                      }
                    </mat-radio-group>
                  </div>
                }
              </mat-radio-group>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (options !== null && options.length === 0 && itemName !== 'Date' && !isOptionsEmpty) {
    <div class="filter-content pt-5 pl-5 pb-5 pr-5">No {{ ftitle | lowercase }} found</div>
  }

  <div class="filter-footer" [ngClass]="itemName === 'Date' ? 'text-right' : 'text-center'">
    <button data-cy="filter-popup-clear-button" mat-flat-button class="mat-secondary" [disabled]="isEnableClear" (click)="clearFilter(ftitle, foptions, item)" id="clearFIlterPopup">Clear</button>
    <button data-cy="filter-popup-apply-button" mat-flat-button class="mat-primary" [disabled]="dirtyFlag" (click)="apply(item)" id="applyFIlterPopup">Apply</button>
  </div>
</div>
